import { Fragment, useEffect, useRef, useState } from 'react';
import styles from './index.less';
import { Dialog, SwipeAction, SwipeActionRef } from 'antd-mobile';
import { Action } from 'antd-mobile/es/components/swipe-action';
import FloatButton from '@/components/FloatButton';

import { history, useModel } from '@umijs/max';

import { formattedDate } from '@/utils/format';
import { HouseType } from '@/pages/House/interface';
import { queryUnBindHouse } from '@/pages/House/service';
import NoData from '@/components/NoData';

const House = () => {
  const ref = useRef<SwipeActionRef>(null);

  const { houseList, handleQueryBindHouse, handleBindHouse } = useModel(
    'useHouse',
    (model) => ({
      houseList: model.houseList,
      handleQueryBindHouse: model.handleQueryBindHouse,
      handleBindHouse: model.handleBindHouse,
    }),
  );

  const [deleteHouseItem, setDeleteHouseItem] = useState<HouseType>();

  useEffect(() => {
    handleQueryBindHouse();
  }, []);

  const onActionsReveal = (item: HouseType) => {
    setDeleteHouseItem(item);
  };

  const RightAction: Action[] = [
    {
      key: 'delete',
      text: '删除',
      color: 'danger',
      onClick: async () => {
        await Dialog.confirm({
          content: '确定删除该房屋吗？',
          onConfirm: async () => {
            await queryUnBindHouse(deleteHouseItem?.id).then((res) => {
              if (res?.code === 200) {
                handleQueryBindHouse();
              }
            });
          },
          onClose: () => {
            ref.current?.close();
          },
        });
      },
    },
  ];

  const handleAddHouse = () => {
    history.push('/house/bind');
  };

  return (
    <Fragment>
      <div className={styles.container}>
        {houseList.length ? (
          <>
            {houseList.map((item) => (
              <div className={styles['house-list']} key={item.id}>
                <SwipeAction
                  ref={ref}
                  rightActions={RightAction}
                  key={item.id}
                  onActionsReveal={() => onActionsReveal(item)}
                >
                  <div>
                    {item.isDefault === 1 && (
                      <div className={styles['default-label']}>默认房屋</div>
                    )}
                    <div
                      style={{ paddingTop: item.isDefault ? 2 : 18 }}
                      className={styles.house}
                    >
                      <div>
                        <p>{item.roomNum}</p>
                        <span>{formattedDate(item.checkInTime)}</span>
                      </div>
                      {item.isDefault !== 1 && (
                        <span
                          onClick={() =>
                            handleBindHouse(item.id!, item.roomId!)
                          }
                        >
                          设为默认房屋
                        </span>
                      )}
                    </div>
                  </div>
                </SwipeAction>
              </div>
            ))}
          </>
        ) : (
          <NoData />
        )}
      </div>
      <FloatButton btnClick={handleAddHouse} type={'house'} />
    </Fragment>
  );
};

export default House;
